import React from 'react'
import { l } from '@manychat/manyui'

export const WAPartnerAppUninstalled = () => {
  return (
    <span>
      {l.translate(
        'WhatsApp channel disconnected due to uninstalled WhatsApp Business Application',
      )}
    </span>
  )
}
